import { gql } from "@apollo/client";

const SUPPORT_TICKET_FIELDS = `
  id
  saleOrderCode
  saleOrderExternalId
  issueSupportTemplateId
  issueSupportTemplateName
  providerContactId
  providerName
  contactType
  priority
  compiledSubject
  compiledBody
  sentToEmail
  emailStatus
  emailSentAt
  createdAt
  createdByName
`;

export const GET_SUPPORT_TICKET_EMAIL_PREVIEW = gql`
  query SupportTicketEmailPreview($request: SupportTicketRequestInput!) {
    supportTicketEmailPreview(request: $request) {
      subject
      body
      toEmail
      providerName
    }
  }
`;

export const GET_SUPPORT_TICKETS = gql`
  query GetSupportTickets($filter: SupportTicketSearchInput, $pageSize: Int = 25, $pageNumber: Int = 0) {
    supportTickets(filter: $filter, pageSize: $pageSize, pageNumber: $pageNumber) {
      count
      pageSize
      pageNumber
      items {
        ${SUPPORT_TICKET_FIELDS}
      }
    }
  }
`;

export const GET_SUPPORT_TICKET_BY_ID = gql`
  query GetSupportTicket($id: UUID!) {
    supportTicket(id: $id) {
      ${SUPPORT_TICKET_FIELDS}
    }
  }
`;
